// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-BrandingLogo {
  display: flex;
  width: 100%;
}
.FF-BrandingLogo--left {
  justify-content: flex-start;
}
.FF-BrandingLogo--center {
  justify-content: center;
}
.FF-BrandingLogo--right {
  justify-content: flex-end;
}

.FF-BrandingLogo-img {
  height: 3rem;
  width: 3rem;
  max-height: 3rem;
  max-width: 3rem;
  object-fit: contain;
  transition: all var(--transition-quick-in-out);
}
.FF-FormManagement .FF-BrandingLogo-img {
  height: 3rem;
  width: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/features/FormBuilder/components/Branding/BrandingLogo/BrandingLogo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".FF-BrandingLogo {\n  display: flex;\n  width: 100%;\n}\n.FF-BrandingLogo--left {\n  justify-content: flex-start;\n}\n.FF-BrandingLogo--center {\n  justify-content: center;\n}\n.FF-BrandingLogo--right {\n  justify-content: flex-end;\n}\n\n.FF-BrandingLogo-img {\n  height: 3rem;\n  width: 3rem;\n  max-height: 3rem;\n  max-width: 3rem;\n  object-fit: contain;\n  transition: all var(--transition-quick-in-out);\n}\n.FF-FormManagement .FF-BrandingLogo-img {\n  height: 3rem;\n  width: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
